import { render, staticRenderFns } from "./WebsiteWizardGeneralForm.vue?vue&type=template&id=60097ce3&scoped=true&"
import script from "./WebsiteWizardGeneralForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteWizardGeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60097ce3",
  null
  
)

export default component.exports